import { Component } from '@angular/core';

@Component({
  selector: 'lib-design-system',
  imports: [],
  template: `
    <p>
      design-system works!
    </p>
  `,
  styles: ``
})
export class DesignSystem {

}
